import { useState } from 'react';
import { Textarea } from '@/components/ui/textarea';
import { ChevronDown, ChevronUp } from 'lucide-react';

export function ExpandableTextarea({ value, onChange, className = '', rows = 2, expandedRows = 8, placeholder, ...props }) {
  const [expanded, setExpanded] = useState(false);
  const hasContent = value && value.length > 0;

  return (
    <div className="relative">
      <Textarea
        value={value}
        onChange={onChange}
        className={`${className} transition-[height] duration-150`}
        rows={expanded ? expandedRows : rows}
        placeholder={placeholder}
        {...props}
      />
      {hasContent && (
        <button
          type="button"
          onClick={() => setExpanded(e => !e)}
          className="absolute right-2 bottom-1.5 flex items-center gap-0.5 text-xs text-muted-foreground hover:text-primary transition-colors px-1 py-0.5 rounded bg-background/80 backdrop-blur-sm border border-border/50"
          data-testid="expand-textarea-toggle"
        >
          {expanded ? <><ChevronUp className="h-3 w-3" /> Less</> : <><ChevronDown className="h-3 w-3" /> More</>}
        </button>
      )}
    </div>
  );
}
